export module PushNotificationsVMs {
    export enum MatchRequestPushEnum {
        MatchRequestAssigned
    }
}
